export default __webpack_public_path__ + "media/zurb/img/experience-design/usability_audit-17913b999f5c2953c7a556d4763d0071.png";